import Vue from 'vue';
import VConsole from 'vconsole';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI, { Loading } from 'element-ui';
import { sleep } from '@/utils/util';
import locale from 'element-ui/lib/locale/lang/en';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, {locale});
Vue.config.productionTip = false;
// new VConsole();

async function getUserInfo() {
  const loading = Loading.service({
    fullscreen: true,
    customClass: 'app-loading',
    background: '#1c1d21'
  });
  const pageURL = window.location.href;

  if (/\/campaigns/.test(pageURL)) {
    document.title = 'Campaigns';
  }

  if (/\/notify/.test(pageURL)) {
    document.title = 'Notify';
  }
  
  await sleep(10);
  await Promise.all([
    store.dispatch('updateAppInfo'),
    store.dispatch('updateUserInfo')
  ]);
  loading.close();
}

Promise.all([
  getUserInfo()
]).then(() => {
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');
});
